// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Vj-z","tupacHeader":"Wj-z","tupacHeader2":"Xj-z","tupacMenu":"Yj-z","tupacMenu2":"Zj-z","tupacMain":"_j-z","tupacMain2":"ak-z"};